import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, options, references } from '@apexdesigner/schema-tools';

export const messageListener = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    boundaryEventId: z
      .string()
      .describe('The boundary event that created this listener'),

    messageName: z
      .string()
      .nullable()
      .optional()
      .describe('Name of the message being waited for'),

    interrupting: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether this boundary event cancels the parent activity'),

    status: options([
      { value: 'Active', name: 'Active' },
      { value: 'Paused', name: 'Paused' },
      { value: 'Triggered', name: 'Triggered' },
      { value: 'Complete', name: 'Complete' },
      { value: 'Canceled', name: 'Canceled' },
    ])
      .nullable()
      .optional()
      .describe('Current state of this listener'),

    completedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When the message was received'),

    messageData: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe(
        "The caught message's payload, in scope as message for the element's before-complete hook and output mappings",
      ),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('updatedAt'),

    tokenId: z.uuid().hidden().describe('Foreign key to Token'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    token: belongsTo('Token'),

    tenant: references('Tenant'),
  })
  .describe('Waits for a specific message to arrive')
  .as('MessageListener');

export { messageListener as messageListenerSchema };
